export * from '@primeuix/themes/lara/textarea';
export { default } from '@primeuix/themes/lara/textarea';
